<template>
  <section class="coupons">
    <section class="listing">
      <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="refresh" ref="list">
        <ul>
          <template v-if="listing.length">
            <li v-for="(item, index) in listing" :key="index" @click="useCoupon(item)">
              <div class="hd">
                <div class="money" v-if="item.type == 1 || item.type == 2">
                  ￥<strong>{{ item.discount_money }}</strong>
                </div>
                <div class="discount" v-else-if="item.type == 3">
                  <strong>{{ item.discount_rate }}</strong>折
                </div>
                <div class="desc">{{ item.use_rule_text }}</div>
              </div>
              <div class="bd">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.end_time }} 到期</div>
                <div class="use" v-if="item.status == 0">立即使用</div>
                <div class="danger" v-if="item.being_expire == 1">将到期</div>
                <div class="normal" v-if="item.status == 1 || item.status == 2">
                  <span>已使用</span>
                </div>
                <div class="normal" v-if="item.status == 3">
                  <span>已过期</span>
                </div>
              </div>
            </li>
          </template>
          <li class="empty" v-else>
            暂无内容
          </li>
        </ul>
      </van-list>
    </section>

    <section class="bottom-line">
      <p>我是有底线的</p>
    </section>

    <!-- <mall-float-navigator /> -->
  </section>
</template>

<script>
import status from '../order-status';
import { enums } from '@module/helper/filters';
// import MallFloatNavigator from '../components/FloatNavigator';

export default {
  name: 'Coupons',

  components: {
  },

  filters: {
    orderStatus(value) {
      return enums(value, status);
    }
  },

  data() {
    return {
      listing: [],
      page: 1,
      loading: false,
      finished: false
    }
  },

  activated() {
    this.page = 1;
    this.listing = [];
    this.loading = false;
    this.finished = false;

    this.$refs.list.check();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getUserCouponList', {
        data: {
          page: this.page,
          num: 10
        }
      });

      this.$toast.clear();

      this.loading = false;

      if (code === 1) {
        this.page++;

        if (data.length > 0) {
          this.listing.push(...data);

          if (data.length < 10) {
            this.finished = true;
          }
        }
        else {
          this.finished = true;
        }
      }
      else {
        this.finished = true;
      }
    },

    useCoupon(item) {
      if (item.status === 0) {
        if (item.jumpurl) {
          window.location = item.jumpurl;
        }
        else {
          this.$router.push(`/homes/post-production`);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/coupons.scss";
</style>
